import React from 'react';
import AboutUsLayer from '../Layers/ServicesLayer.jsx';
import Clients from '../Clients/Clients.jsx';
import SafetyConsultants from './About_Content/Content.jsx';
import OurAchievements from './Achievements/Our_Achievements.jsx';
import Layer from './ِAbout-Layer/Layer.jsx';
import ScrollToTop from '../../ScrollToTop.js';

const AboutUs = () => {
    return <>
      <ScrollToTop />

        <AboutUsLayer/>
        <SafetyConsultants/>
        <OurAchievements/>
        <Layer/>
        <Clients/>
    </>
}

export default AboutUs;
